import { IListingAddAnOwnerForm } from '../ListingAddAnOwner.types';

type IListingAddAnOwnerFormKey = keyof IListingAddAnOwnerForm;

const RequiredFieldForOwner: {
  label: string;
  value: IListingAddAnOwnerFormKey;
}[] = [
  { label: 'listingDetail:name', value: 'first_name' },
  { label: 'listingDetail:surname', value: 'last_name' },
  { label: 'listingDetail:date_of_birth', value: 'date_of_birth' },
  { label: 'listingDetail:residence', value: 'city' },
  { label: 'listingDetail:documentNumber', value: 'id_document_number' },
  {
    label: 'listingDetail:documentExpiryDate',
    value: 'id_document_expiry_date',
  },
  { label: 'listingDetail:taxCode', value: 'tax_code' },
];

export const filterRequiredFieldForAddAnOwner = ({
  index,
  owner,
}: {
  index: number;
  owner: IListingAddAnOwnerForm;
}) => {
  const emptyFields = RequiredFieldForOwner.filter(
    field => !owner[field?.value as keyof IListingAddAnOwnerForm],
  ).map(field => field.label);

  const label =
    index === 0 ? 'listingDetail:addOwner' : 'listingDetail:addOtherOwner';

  return {
    label,
    fields: emptyFields,
  };
};
